export default __webpack_public_path__ + "static/media/git-commit.8f979d54.txt";